import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import * as XLSX from "xlsx";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { getHeader, toastError } from "../../utils/util";
import useApiEp from "../../hooks/useApiEp";
import { toast } from "react-toastify";
import CustomCircularP from "../../widgets/CustomCircularP";
import MuPb from "../../widgets/MuPb";
import DataTable from "../../widgets/DataTable";
import { useNavigate } from "react-router-dom";

const FlowsReport = () => {
  const navigate = useNavigate();
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [exporting, setExporting] = useState(false);

  const { data, isLoading, isError, error } = useApiEp(
    `/message/get-flows-report?page=${page}&limit=${limit}`
  );
  const handleExport = async () => {
    if (exporting) {
      return;
    }
    try {
      setExporting(true);
      const response = await axios.get(
        `${API_ENDPOINT}/message/get-flows-report-export `,
        getHeader()
      );
      const exportData = response.data.map((item) => ({
        campaign: item._id,
        count: item.count,
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      XLSX.writeFile(workbook, "exported_data.xlsx");
    } catch (error) {
      toastError(error);
    } finally {
      setExporting(false);
    }
  };
  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/flow-response/${id}`);
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);

  if (isLoading) {
    return <MuPb />;
  }

  return (
    <Box p={3}>
      <CustomCircularP show={exporting} />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Flows Reports</Typography>
        <Button variant="contained" onClick={handleExport}>
          Export to Excel
        </Button>
      </Box>

      <DataTable
        sx={{ mb: 1 }}
        columns={[
          {
            id: "serial",
            label: "S.No.",
            render: (_v, _row, idx) => (page - 1) * limit + idx + 1,
          },
          { id: "_id", label: "Campaign/Sender" },
          { id: "count", label: "Response Count" },
        ]}
        actions={["view"]}
        rows={data?.data ?? []}
        page={page}
        itemsPerPage={limit}
        totalPages={data?.totalPages ?? 1}
        onPageChange={setPage}
        onAction={handleAction}
        itemsPerPageOptions={[20, 30, 50, 100]}
        onItemsPerPageChange={(lm) => {
          setLimit(lm);
        }}
        paginationAlign="end"
      />
    </Box>
  );
};

export default FlowsReport;
